import ApiService from "../api";

export default class MeuUsuarioService extends ApiService {

    constructor() {
        super('/api/usuarios/me')
    }

    buscarPerfil() {
        return this.get(``)
    }

    alterarSenha(dto) {
        return this.post(`/alterar-senha`, dto)
    }

    atualizarPreferencias(dto) {
        return this.put(`/preferencias`, dto)
    }

    buscarAssinatura() {
        return this.get(`/assinatura`)
    }

    baixarAssinaturaImagem() {
        return this.getFile(`/assinatura/imagem`)
    }

    salvarAssinatura(arquivo) {
        const formData = new FormData()
        formData.append("arquivo", arquivo)

        return this.post(`/assinatura`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
    }

    excluirAssinatura() {
        return this.delete(`/assinatura`)
    }
}
